import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useLang } from "@/contexts/LangContext";
import Layout from "@/components/Layout";
import ProductCard from "@/components/ProductCard";
import StoreCard from "@/components/StoreCard";

export default function Favorites() {
    const { t } = useLang();
    const [data, setData] = useState({ products: [], stores: [] });

    useEffect(() => {
        api.get("/favorites").then((r) => setData(r.data));
    }, []);

    return (
        <Layout>
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
                <h1 className="text-3xl md:text-4xl font-black text-espresso">{t("favorites")}</h1>

                <div className="mt-8">
                    <h2 className="text-xl font-bold text-espresso mb-4">{t("products")}</h2>
                    {data.products.length === 0 ? (
                        <div className="text-muted-foreground text-sm">{t("noResults")}</div>
                    ) : (
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            {data.products.map((p) => <ProductCard key={p.product_id} product={p} />)}
                        </div>
                    )}
                </div>

                {data.stores.length > 0 && (
                    <div className="mt-10">
                        <h2 className="text-xl font-bold text-espresso mb-4">{t("stores")}</h2>
                        <div className="grid md:grid-cols-3 gap-6">
                            {data.stores.map((s) => <StoreCard key={s.store_id} store={s} />)}
                        </div>
                    </div>
                )}
            </div>
        </Layout>
    );
}
